import { GET_ABSENCES } from "./absencesConstants";
import { setValue } from "../../lib/immutable_wrapper";
import {
    SWITCH_ABSENCES_MODE,
    SET_STATUS_FILTER,
    SET_ABSENCE_DETAILS,
    GET_ABSENCES_ACTIVITY_TYPES,
    SET_ABSENCE_CREATION_FIELDS,
    SET_REDIRECT_URL,
    SET_EDITION_STATE,
    GET_REFUSE_REASONS,
} from "./absencesConstants";
import { ALL_SELECT_OPTION } from "../../constants";

const initialState = {
    absences: [],
    activityTypes: [],
    employees: [],
    absencesToValidateMode: false,
    absencesStatusFilter: ALL_SELECT_OPTION,
    editionState: {
        creationMode: false,
        updateMode: false,
        validationMode: false,
    },
    absenceCreationFields: {
        id: null,
        employeeId: 0,
        defaultAbsenceTypeId: 0,
        status: "new",
        counters: null,
        nbDays: 0,
        comment: "",
    },
    absenceDetails: [],
    redirectUrl: null,
    refuseReasons: [],
};

export function absences(state = initialState, action) {
    switch (action.type) {
        case GET_ABSENCES:
            return setValue(state, ["absences"], action.absences);
        case SWITCH_ABSENCES_MODE:
            return setValue(state, ["absencesToValidateMode"], action.absencesToValidateMode);
        case SET_STATUS_FILTER:
            return setValue(state, ["absencesStatusFilter"], action.statusFilter);
        case SET_ABSENCE_DETAILS:
            return setValue(
                state,
                ["absenceDetails"],
                action.absenceDetails.filter((d) => !d.deleted)
            );
        case GET_ABSENCES_ACTIVITY_TYPES:
            return setValue(state, ["activityTypes"], action.activityTypes);
        case SET_ABSENCE_CREATION_FIELDS:
            return setValue(state, ["absenceCreationFields"], action.absenceCreationFields);
        case SET_REDIRECT_URL:
            return setValue(state, ["redirectUrl"], action.url);
        case SET_EDITION_STATE:
            return setValue(state, ["editionState"], action.state);
        case GET_REFUSE_REASONS:
            return setValue(state, ["refuseReasons"], action.reasons);
        default:
            return state;
    }
}
